export default __webpack_public_path__ + "static/media/Banner_Pack_Series1.810dde82.png";